import { Col, Flex, Form, Row } from "antd";
import { MonedaRadio } from "../../reusable/MonedaRadio";
import { ButtonsChangeSteps } from "../ButtonsChangeSteps";

export const TipoCambioMonedaDiv = ({ stepsLength }) => {
  return (
    <Row>
      <Col span={12}>
        <Form.Item
          name="moneda"
          rules={[
            {
              required: true,
              message: "El tipo de moneda es obligatorio",
            },
          ]}
          required={false}
        >
          <MonedaRadio disabled />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Flex justify="flex-end">
          <ButtonsChangeSteps stepsLength={stepsLength} />
        </Flex>
      </Col>
    </Row>
  );
};
